/* src/app/order/components/estimate-questions-details/long-option-single-choice-details/long-option-single-choice-details.style.scss */
.long-option-single-choice-question {
  display: flex;
  flex-direction: column;
}
.long-option-single-choice-question .question {
  margin-bottom: 0;
  display: inline;
}
.long-option-single-choice-question .question span {
  vertical-align: middle !important;
  font-size: 0.938rem;
  font-weight: bold;
  line-height: 1.6;
  color: #007d40;
}
.long-option-single-choice-question .answer {
  margin-bottom: 20px;
  font-size: 0.938rem;
  line-height: 1.47;
}
.text-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
@media screen and (max-width: 767px) {
  .attached-question {
    display: flex;
    flex-direction: column-reverse;
  }
}
/*# sourceMappingURL=long-option-single-choice-details.style.css.map */
